import * as types from './mutation-types'
import api from '@/utils/api'

export default {
  [types.AUTH_REQUEST]: (state) => {
  },
  [types.USER_REQUEST]: (state) => {
  },
  [types.USER_ERROR]: (state) => {
  },
  [types.AUTH_SUCCESS]: (state, token) => {
    state.token = token
    localStorage.setItem('user-token', token) // store the token in localstorage
    api.defaults.headers.common['Authorization'] = 'Token ' + token
  },
  [types.AUTH_ERROR]: (state) => {
    localStorage.removeItem('user-token') // if the request fails, remove any possible user token if possible
  },
  [types.AUTH_LOGOUT]: (state) => {
    state.token = ''
    localStorage.removeItem('user-token')
    delete api.defaults.headers.common['Authorization']
  },
  [types.USER_SUCCESS]: (state, resp) => {
    state.user = resp.data
  },
  [types.ALL_PACKAGES_SUCCESS]: (state, resp) => {
    state.initial.allPackages = resp.data
  },
  [types.ALL_TRAINERS_SUCCESS]: (state, resp) => {
    state.initial.allTrainers = resp.data
  },
  [types.TRAINER_SUCCESS]: (state, data) => {
    state.trainer = data
  },
  [types.RUNNER_SUCCESS]: (state, data) => {
    state.runner = data
  },
  [types.RUNNER_DATA_FILLED]: (state) => {
    state.runner.data_filled = true
  },
  [types.RUNNERS_TRAINER_SUCCESS]: (state, data) => {
    state.runnersTrainer = data
  },
  [types.TRAINERS_RUNNERS_SUCCESS]: (state, data) => {
    state.trainerRunners = data
  },
  [types.ADMIN_RUNNERS_SUCCESS]: (state, data) => {
    state.adminRunners = data
  },
  [types.ADMIN_TRAINERS_SUCCESS]: (state, data) => {
    state.adminTrainers = data
  },
  [types.ALL_WORKOUTS_TEMPLATES_SUCCESS]: (state, resp) => {
    state.initial.allWorkoutsTemplates = resp.data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js